import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import { updateData } from "../../../hooks/update";

function WorkUniquepage() {
  const { CSRApi } = apiPath;
  const { id } = useParams();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData]
      .filter((item) => item.slug === "work")
      .filter((item) => item._id === id)[0];
    setFilteredData(filtereddata);
  }, [csrData]);

  const {
    ourWorkTitle,
    ourWorkSubTitle,
    ourWorkDetails,
    ourWorkSingleImg,
    ourWorkImages,
    ourWorkVideoUrl,
    _id,
  } = filteredData ?? {};

  const aboutLinksData = [];
  if (ourWorkVideoUrl?.length > 0) {
    ourWorkVideoUrl?.map((item, index) => {
      aboutLinksData.push({
        label: `Video url ${index}`,
        type: "text",
        name: "",
        defaultValue: item.url,
        required: false,
      });
    });
  } else {
    [{}]?.map((item, index) => {
      aboutLinksData.push({
        label: `Video url ${index}`,
        type: "text",
        name: "",
        defaultValue: "",
        required: false,
      });
    });
  }

  const data = [
    {
      elementType: "file",
      label: "Work Featured Image",
      type: "text",
      name: "ourWorkSingleImg",
      defaultValue: ourWorkSingleImg,
      required: true,
    },
    {
      elementType: "textField",
      label: "Work Title",
      type: "text",
      name: "ourWorkTitle",
      defaultValue: ourWorkTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Work Subtitle",
      type: "text",
      name: "ourWorkSubTitle",
      defaultValue: ourWorkSubTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Work Details",
      type: "text",
      name: "ourWorkDetails",
      defaultValue: ourWorkDetails,
      required: true,
    },
  ];

  const imagesData = [];
  ourWorkImages?.map((item, index) => {
    imagesData.push({
      label: `Gallery Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item.url,
      required: false,
    });
  });

  const nestedData = [
    {
      elementType: "file",
      label: "Gallery Image",
      name: "ourWorkImages",
      multipleData: imagesData,
      multiple: true,
      fullCol: true,
      required: false,
    },
    {
      elementType: "textField",
      label: "Video Url",
      type: "text",
      name: "ourWorkVideoUrl",
      required: true,
      multiple: true,
      fullCol: true,
      multipleData: aboutLinksData,
      placeholder: "Enter Embed ID Only",
    },
  ];

  const useData = data.concat(nestedData);

  const update = (data) => {
    const fData = data.ourWorkImages.map((item) => {
      let obj = {};
      obj.url = item;
      return obj;
    });
    data.ourWorkImages = fData;
    data.slug = "work";
    data.ourWorkVideoUrl = data.ourWorkVideoUrl.map((item) => {
      let obj = {};
      obj.url = item;
      return obj;
    });
    updateData(`${CSRApi}/${_id}`, data, true);
  };

  return (
    <div>
      {_id && (
        <GlobalForm data={useData} nestedData={nestedData} update={update} />
      )}
    </div>
  );
}

export default WorkUniquepage;
